






















































import Vue from "vue";
import OutputCsv from "@/components/end_parts/OutputCsv.vue";
import proj4 from "proj4";
import { IofileJson, CsvParamJson } from "types/opts-json";
import { send } from "process";

const D2R = 0.01745329251994329577;
const R2D = 57.29577951308232088;

export default Vue.extend({
  components: {
    OutputCsv,
  },
  props: {
    outputKey: {
      // 出力パラメータを抽出するためのキー
      type: String,
      default: String,
    },
    changeFile: {
      // 入力されたファイルを編集した投影変換を行うための文字列(最大6行)
      type: String,
      default: String,
    },
    outputFileConsole: {
      // コンソールに出力するために親に送る文字列
      type: String,
      default: String,
    },
    resultLink: {
      // 投影変換後のファイルをダウンロードするためのlink
      type: String,
      default: String,
    },
    outputConvert: {
      // 投影変換後のファイルをダウンロードするためのlink
      type: String,
      default: String,
    },
    inputThirdHeader: {
      type: Number,
      default: Number,
    },
    outputJson: {
      // opts.jsonのoutput以下を抽出したパラメータ
      type: Object,
      default: Object,
    },
    inputHeaderBoolean: Boolean, // 入力パラメータのheaderの設定
    outputHeaderBoolean: Boolean, // 出力パラメータのheaderの設定
    disableEvent: Boolean, // 出力パラメータのheaderの設定
  },
  data() {
    return {
      IofileJson: {} as IofileJson, // opts.jsonのoutput以下を抽出したパラメータ
      csvParamJson: {} as CsvParamJson, // opts.jsonのoutputのparameter以下を抽出したパラメータ
      regex: new RegExp(/^-?(-?[0-9]*.?([0-9]*))( -?([0-9])*.?([0-9]*))*$/), //区切り文字がスペースかどうかを判定する正規表現
      regexs: new RegExp(/^-?(-?[0-9]*.?([0-9]*))(,-?([0-9])*.?([0-9]*))*$/), //区切り文字がカンマかどうかを判定する正規表現
      regexss: new RegExp(/^-?(-?[0-9]*.?([0-9]*))(\t-?([0-9])*.?([0-9]*))*$/), //区切り文字がカンマかどうかを判定する正規表現
      regexundefined: new RegExp(
        /^-?(-?[0-9]*.?([0-9]*))( -?([0-9])*.?([0-9]*))?( undefined)$/
      ), //区切り文字がスペースかどうかを判定する正規表現
      regexsundefined: new RegExp(
        /^-?(-?[0-9]*.?([0-9]*))(,-?([0-9])*.?([0-9]*))?(,undefined)$/
      ), //区切り文字がカンマかどうかを判定する正規表現
      regexssundefined: new RegExp(
        /^-?(-?[0-9]*.?([0-9]*))(\t-?([0-9])*.?([0-9]*))?(\tundefined)$/
      ), //区切り文字がカンマかどうかを判定する正規表現
      fileName: "", // 出力ファイル名(初期値は入力促進メッセージ)
      regexCSV: new RegExp(/.csv$/), // 入力された出力ファイル名に.csvが入っているかどうかを判定する正規表現
      columnName: {
        "background-color": "#BAD3FF",
        padding: "10px",
        margin: "0px -15px",
        "border-top": "solid 1px #DDDDDD",
        "border-right": "solid 1px #DDDDDD",
        "border-bottom": "solid 1px #DDDDDD",
        "border-left": "solid 1px #DDDDDD",
      },
      columnCenter: {
        padding: "5px",
        margin: "0px -15px",
        "border-right": "solid 1px #DDDDDD",
        "border-left": "solid 1px #DDDDDD",
        "border-bottom": "solid 1px #DDDDDD",
      },
      column: {
        padding: "5px",
        margin: "0px -15px",
        "border-right": "solid 1px #DDDDDD",
        "border-bottom": "solid 1px #DDDDDD",
        "border-left": "solid 1px #DDDDDD",
      },
    };
  },
  watch: {
    outputJson: {
      handler() {
        this.reload();
      },
      deep: true,
    },
  },
  created() {
    this.fileName = "ファイル名を入力してください";
    if (this.outputJson[this.outputKey]["local_path"] !== "") {
      this.fileName = this.outputJson[this.outputKey]["local_path"];
    }
    this.reload();
  },
  methods: {
    reload() {
      if (this.fileName === "ファイル名を入力してください") {
        this.fileName = String(
          Vue.i18n.translate("opts.output.output_placeholder")
        );
      }
      if (this.fileName === "Download the file name") {
        this.fileName = String(
          Vue.i18n.translate("opts.output.output_placeholder")
        );
      }
      this.IofileJson = this.outputJson[this.outputKey] as IofileJson;
      this.csvParamJson = this.IofileJson.parameter as CsvParamJson;
    },
    pre() {
      // 投影変換処理
      let noHeader = "";
      if (this.changeFile !== "error") {
        if (this.inputHeaderBoolean === true) {
          // 入力ファイルにヘッダがあった場合ヘッダを削除
          noHeader = String(this.deliteHeader(this.changeFile));
        } else {
          noHeader = String(this.changeFile);
        }
        // ファイルが入力されている場合だけ実行
        if (noHeader !== "undefined") {
          const LineSplit = noHeader.split("\n");
          const result = [];
          let outputlog = "";
          for (let i = 0; i < LineSplit.length; i++) {
            const SeparaterSplit = LineSplit[i].split(
              this.outputJson.input.parameter.separator
            );
            if (SeparaterSplit.length === 1) {
              outputlog = "エラー";
              this.$emit("outputFileConsole", outputlog);
              return;
            }
            if (
              this.regex.test(LineSplit[i]) ||
              this.regexs.test(LineSplit[i]) ||
              this.regexss.test(LineSplit[i]) ||
              this.regexundefined.test(LineSplit[i]) ||
              this.regexsundefined.test(LineSplit[i]) ||
              this.regexssundefined.test(LineSplit[i])
            ) {
              let IsNone = false;
              let IsUtm = false;
              let IsLambert = false;
              let IsMercator = false;
              let ArgProj = "+proj=";
              let ArgEllps = " +ellps=";
              let ArgParam = "";
              const firstProjection = "EPSG:4326";
              // const secondProjection = "+proj=gnom +lat_0=90 +lon_0=0 +x_0=6300000 +y_0=6300000 +ellps=WGS84 +datum=WGS84 +units=m +no_defs";
              if (this.outputJson.transform.projection.map === "lambert") {
                ArgProj += "lcc";
                IsLambert = true;
              } else if (
                this.outputJson.transform.projection.map === "mercator"
              ) {
                ArgProj += "merc";
                IsMercator = true;
              } else if (this.outputJson.transform.projection.map === "tm") {
                ArgProj += "tmerc";
              } else if (this.outputJson.transform.projection.map === "utm") {
                ArgProj += "utm";
                IsUtm = true;
              } else if (this.outputJson.transform.projection.map === "none") {
                ArgProj += "longlat";
                IsNone = true;
              } else {
                ArgProj += "map";
              }

              const ellps = this.outputJson.transform.projection
                .ellps as string;
              if (ellps === "bessel") {
                ArgEllps += ellps;
                if (IsNone === true) {
                  ArgEllps += " +towgs84=-146.414,507.337,680.507,0,0,0,0";
                }
              } else if (ellps == "grs80") {
                ArgEllps += "GRS80";
              } else if (
                this.outputJson.transform.projection.terr === "wgs84"
              ) {
                ArgEllps += "WGS84 +datum=WGS84";
              } else if (ellps == "" || ellps === "undefined") {
                if (this.outputJson.transform.projection.a != 0) {
                  ArgEllps =
                    " +a=" + String(this.outputJson.transform.projection.a);
                  if (this.outputJson.transform.projection.isRf) {
                    ArgEllps +=
                      ",+rf=" + String(this.outputJson.transform.projection.rf);
                  } else {
                    ArgEllps +=
                      ",+b=" + String(this.outputJson.transform.projection.b);
                  }
                }
              } else {
                ArgEllps += ellps;
              }

              if (IsNone === false) {
                if (IsUtm === true) {
                  const zone = this.outputJson.transform.projection.zone;
                  const len = zone.length;
                  ArgParam += " +zone=" + zone.substr(0, len - 1);
                  if (zone.substr(len - 2, 1) == "s") {
                    ArgParam += " +south";
                  }
                } else {
                  ArgParam +=
                    " +lat_0=" +
                    this.outputJson.transform.projection.origin.lat;
                  ArgParam +=
                    " +lon_0=" +
                    this.outputJson.transform.projection.origin.lon;
                  if (IsLambert === true) {
                    ArgParam +=
                      " +lat_1=" +
                      this.outputJson.transform.projection.stdpal[0];
                    ArgParam +=
                      " +lat_2=" +
                      this.outputJson.transform.projection.stdpal[1];
                  } else {
                    if (IsMercator === false) {
                      ArgParam +=
                        " +k=" + this.outputJson.transform.projection.scale;
                      ArgParam +=
                        " +x_0" +
                        this.outputJson.transform.projection["false_ne"][0];
                      ArgParam +=
                        " +y_0" +
                        this.outputJson.transform.projection["false_ne"][0];
                    }
                  }
                }
              }
              const secondProjection =
                ArgProj + ArgEllps + ArgParam + " +units=m +no_defs";
              //I'm not going to redefine those two in latter examples.
              let TransformResult = [0, 0];
              if (this.outputConvert === "LMtoXY") {
                //SeparaterSplit[0] = String(Number(SeparaterSplit[0]) * D2R);
                //SeparaterSplit[1] = String(Number(SeparaterSplit[1]) * D2R);
                TransformResult = proj4(firstProjection, secondProjection, [
                  Number(SeparaterSplit[0]),
                  Number(SeparaterSplit[1]),
                ]);
              }
              if (this.outputConvert === "XYtoLM") {
                TransformResult = proj4(secondProjection, firstProjection, [
                  Number(SeparaterSplit[0]),
                  Number(SeparaterSplit[1]),
                ]);
                //TransformResult[0] = TransformResult[0] * R2D; // 何故か度で戻ってくるので不要
                //TransformResult[1] = TransformResult[1] * R2D;
              }
              result[i] = [
                TransformResult[0],
                TransformResult[1],
                SeparaterSplit[2],
              ];
              let c = "";
              for (let j = 0; j < 3; j++) {
                c += result[i][j];
                if (j < 2) {
                  c += this.csvParamJson.separator;
                }
              }
              c += "\n";
              if (this.inputThirdHeader === -1) {
                outputlog += this.inputDeliteHeader(c);
              } else {
                if (this.csvParamJson.columns[2] === -1) {
                  outputlog += this.inputDeliteHeader(c);
                } else {
                  outputlog += c;
                }
              }
            } else {
              outputlog = "エラー";
              this.$emit("outputFileConsole", outputlog);
              return;
            }
          }
          if (this.outputHeaderBoolean === true) {
            // 出力ファイルの「ヘッダをあり」にチェックがついている場合先頭行にヘッダを追加
            outputlog = String(this.addHeader(outputlog));
          }
          this.$emit("outputFileConsole", outputlog);
        }
      } else {
        // ファイルが入力されていない場合コンソールにメッセージを表示
        this.$emit(
          "outputFileConsole",
          String(Vue.i18n.translate("opts.output.output_placeholder"))
        );
      }
    },
    inputDeliteHeader(data: string) {
      let returnData = "";
      let result = data.split(this.csvParamJson.separator);
      for (let i = 0; i < 2; i++) {
        returnData += result[i];
        if (i < 1) {
          returnData += this.csvParamJson.separator;
        }
      }
      returnData += "\n";
      return returnData;
    },
    deliteHeader(file: string) {
      // ヘッダを削除
      let sendData = "";
      const data = file.split("\n");
      for (let i = 1; i < data.length; i++) {
        const changedata = data[i].split(this.csvParamJson.separator);
        for (let j = 0; j < changedata.length; j++) {
          sendData += changedata[j];
          if (j < changedata.length - 1) {
            sendData += this.csvParamJson.separator;
          }
        }
        if (i < data.length - 1) {
          sendData += "\n";
        }
      }
      return sendData;
    },
    addHeader(file: string) {
      // ヘッダを追加
      if (this.csvParamJson["header_names"] !== undefined) {
        let sendData = "";
        if (this.csvParamJson.columns[2] === -1) {
          sendData =
            this.csvParamJson["header_names"][0] +
            this.csvParamJson.separator +
            this.csvParamJson["header_names"][1] +
            "\n";
        } else {
          if (this.inputThirdHeader === -1) {
            sendData =
              this.csvParamJson["header_names"][0] +
              this.csvParamJson.separator +
              this.csvParamJson["header_names"][1] +
              "\n";
          } else {
            sendData =
              this.csvParamJson["header_names"][0] +
              this.csvParamJson.separator +
              this.csvParamJson["header_names"][1] +
              this.csvParamJson.separator +
              this.csvParamJson["header_names"][2] +
              "\n";
          }
        }
        const data = file.split("\n");
        for (let i = 0; i < data.length; i++) {
          const changedata = data[i].split(this.csvParamJson.separator);
          for (let j = 0; j < changedata.length; j++) {
            sendData += changedata[j];
            if (j < changedata.length - 1) {
              sendData += this.csvParamJson.separator;
            }
          }
          if (i < data.length - 1) {
            sendData += "\n";
          }
        }
        return sendData;
      }
    },
    clickName() {
      // 出力ファイル名のテキストをクリックした時に文字列を削除(初回だけ)
      if (this.fileName === "ファイル名を入力してください") {
        this.fileName = "";
      }
      if (this.fileName === "Enter the file name") {
        this.fileName = "";
      }
    },
    changeName(value: string) {
      // 出力ファイル名が設定されたときに文字列の最後に「.csv」がついていた場合に「.csv」を削除する
      let csvValue = value;
      if (this.regexCSV.test(String(value))) {
        csvValue = value.replace(/.csv$/, "");
      }
      if (csvValue !== "") {
        csvValue += ".csv";
      }
      this.IofileJson["local_path"] = csvValue;
    },
    transformEvent() {
      this.$emit("transformEvent");
    },
    downloadFile() {
      window.location.href = this.resultLink;
    },
  },
});
